
document.addEventListener("scroll", function () {
  const header = document.querySelector("#main-header");
  if (window.scrollY > 20) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});

// Chat Now Button Functionality
document.addEventListener('DOMContentLoaded', function () {
  const chatNowBtn = document.querySelector('.chat-now-btn');

  if (chatNowBtn) {
    chatNowBtn.addEventListener('click', function (e) {
      e.preventDefault();

      // Wait for Gorgias to be loaded
      const waitForGorgias = setInterval(function () {
        if (window.GorgiasChat) {
          clearInterval(waitForGorgias);
          // Open the chat widget
          window.GorgiasChat.open();
        }
      }, 100);

      // Fallback: try to trigger the chat widget directly
      setTimeout(function () {
        // Try multiple methods to open the chat
        if (window.GorgiasChat) {
          window.GorgiasChat.open();
        } else if (window.gorgiasChat) {
          window.gorgiasChat.open();
        } else {
          // Try to find and click the chat widget button
          const chatWidgetButton = document.querySelector('[data-gorgias-chat-widget-trigger]') ||
            document.querySelector('.gorgias-chat-widget-trigger') ||
            document.querySelector('[class*="chat"][class*="widget"][class*="trigger"]');

          if (chatWidgetButton) {
            chatWidgetButton.click();
          }
        }
      }, 500);
    });
  }
});
